import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'VOLUMEN 1',
  subtitle: 'Fútbol Base U8-U10',
  desc: '50 sesiones completas',
  features: 'Pase · Control · Regate · Juego Colectivo'
}, {
  color: '🟡',
  title: 'VOLUMEN 2',
  subtitle: 'Fútbol Infantil U11-U13',
  desc: '50 sesiones completas',
  features: 'Técnica Avanzada · Sistemas Básicos · Toma de Decisiones'
}, {
  color: '🟠',
  title: 'VOLUMEN 3',
  subtitle: 'Fútbol Juvenil U14-U17',
  desc: '50 sesiones completas',
  features: 'Táctica Avanzada · Alto Rendimiento · Preparación Competitiva'
}, {
  color: '🔴',
  title: 'VOLUMEN 4',
  subtitle: 'Preparación Física',
  desc: 'Protocolos específicos',
  features: 'Velocidad · Agilidad · Resistencia · Prevención de Lesiones'
}, {
  color: '🟣',
  title: 'VOLUMEN 5',
  subtitle: '101 Ejercicios Técnicos',
  desc: '101 ejercicios clasificados',
  features: 'Pase · Control · Tiro · Regate · Situaciones de Partido'
}, {
  color: '🔵',
  title: 'VOLUMEN 6',
  subtitle: 'Táctica y Gestión de Equipo',
  desc: 'Herramientas avanzadas',
  features: 'Evaluación · Seguimiento · Comunicación · Scouting'
}];
const features = ['Planificación anual', 'Sesiones completas', 'Objetivos definidos', 'Progresiones técnicas', 'Variantes para distintos niveles', 'Adaptaciones para grupos reducidos', 'Seguimiento del desarrollo'];
export function WhatYouGet() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-241">
      <div className="max-w-5xl mx-auto" data-id="element-242">
        <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] text-center mb-12 tracking-tight" data-id="element-243">
          Los 6 Volúmenes Completos
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-244">
          {tomos.map(tomo => <div key={tomo.title} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-245">
              <div className="flex items-center gap-3 mb-4" data-id="element-246">
                <span className="text-2xl" data-id="element-247">{tomo.color}</span>
                <div data-id="element-248">
                  <h3 className="font-black text-[#0A0A0A] text-sm tracking-wider uppercase" data-id="element-249">
                    {tomo.title}
                  </h3>
                  <p className="text-[#00A650] font-bold text-lg leading-tight" data-id="element-250">
                    {tomo.subtitle}
                  </p>
                </div>
              </div>
              <p className="text-[#0A0A0A] font-bold text-sm mb-2" data-id="element-251">
                {tomo.desc}
              </p>
              <p className="text-[#5A5A66] text-sm font-medium leading-relaxed mt-auto" data-id="element-252">
                {tomo.features}
              </p>
            </div>)}
        </div>

        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-253">
          <h4 className="text-center font-black text-[#0A0A0A] mb-6 uppercase tracking-wider text-sm" data-id="element-254">
            Qué incluye cada volumen
          </h4>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-255">
            {features.map(f => <span key={f} className="text-[#0A0A0A] text-sm font-bold flex items-center gap-2" data-id="element-256">
                <span className="text-[#00A650] text-lg" data-id="element-257">✅</span> {f}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}